module.exports = __webpack_public_path__ + "static/media/Warrior_DPS.4c9c87a8.png";